import { render, staticRenderFns } from "./HomeBlockList.vue?vue&type=template&id=33082bbf&"
import script from "./HomeBlockList.vue?vue&type=script&lang=js&"
export * from "./HomeBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports